const buttonClassNames = `
  col-span-1
  text-xs md:text-base
  py-1
  text-left
  align-top
  w-full
  h-8 md:h-10
  bg-white
  border-0
  cursor-pointer
`

const sectionParentClassNames = (section) => {
  if (section.hasOwnProperty("parent")) {
    return "text-2xs sm:text-xs h-4 my-0 border border-transparent"
  } else {
    return "hidden"
  }
}

function ButtonText({ section, textAboveTheSection }) {
  return <>
    <p className={sectionParentClassNames(section)}>
      {textAboveTheSection}
    </p>
    <p className="px-1 py-0.5 h-8 md:h-10 m-0">{section.name}</p>
  </>
}

function ActiveButton({ section, textAboveTheSection }) {
  return (
    <button className={buttonClassNames + " text-main-blue font-bold underline"}>
      <ButtonText section={section} textAboveTheSection={textAboveTheSection} />
    </button>
  )
}

function NonActiveButton({ section, textAboveTheSection, onSelect = f => f }) {
  return (
    <button
      className={buttonClassNames + " hover:text-main-blue hover:font-bold hover:underline transition"}
      onClick={() => onSelect({
        sectionId: section.id,
        elementId: "E01",
      })}
    >
      <ButtonText section={section} textAboveTheSection={textAboveTheSection} />
    </button>
  )
}

function SectionSelectionButton({ section, textAboveTheSection, isActive, onSelect = f => f }) {
  if (isActive) {
    return <ActiveButton
      section={section}
      textAboveTheSection={textAboveTheSection}
    />
  } else {
    return <NonActiveButton
      section={section}
      textAboveTheSection={textAboveTheSection}
      onSelect={onSelect}
    />
  }

}

export default SectionSelectionButton;
